module.exports = __webpack_public_path__ + "img/card.8636e10c.png";